import { Component, OnInit } from '@angular/core';

interface Item {
    id: number;
    image: string;
    title: string;
    description: string;
}

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.css'],
})
export class FaqComponent implements OnInit {
    activeFaq:number = 0;

    faqArray:any[] = [
        {
            header: 'presumptive',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Who pays presumptive Tax?', description: 'Who pays presumptive tax...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
                {title: 'What is the rate presumptive Tax?', description: 'The rate of Presumptive tax is...'},
                {title: 'What time rate is presumptive Tax paid?', description: 'Time rate of Presumptive tax is...'},
                {title: 'How do I pay presumptive Tax?', description: 'This is how you pay your presumptive tax...'},
                {title: 'What do I receive after payment of presumptive Tax?', description: 'What you receive is...'},
                {title: 'What happens if I don’t presumptive Tax?', description: 'This is what happens when you fail to pay your Presumptive tax...'}
            ]
        },
        {
            header: 'duties',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Who pays presumptive Tax?', description: 'Who pays presumptive tax...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
            ]
        },
        {
            header: 'levies',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Who pays presumptive Tax?', description: 'Who pays presumptive tax...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
            ]
        },
        {
            header: 'taxes',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Who pays presumptive Tax?', description: 'Who pays presumptive tax...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
            ]
        },
        {
            header: 'mda',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
            ]
        },
        {
            header: 'onLicences',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
            ]
        },
        {
            header: 'permit',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Who pays presumptive Tax?', description: 'Who pays presumptive tax...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
            ]
        },
        {
            header: 'penalty',
            data: [
                {title: 'What is presumptive Tax?', description: 'Presumptive tax is...'},
                {title: 'Who pays presumptive Tax?', description: 'Who pays presumptive tax...'},
                {title: 'Is presumptive Tax backed by law?', description: 'Presumptive tax is backed by law...'},
            ]
        }]

    onActiveFaq(index) {
        this.activeFaq = index;
    }

    ngOnInit(): void {
    }

}
